import DialogSelector from './dialog-selector.vue'

DialogSelector.install = function (Vue) {
	Vue.component(DialogSelector.name, DialogSelector);
}

export default DialogSelector;